/* POLL BAR ANIMATION */

export function initPollAnimation() {
  const bars = document.querySelectorAll('.poll-bar-segment[data-value]');
  if (!bars.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const bar = entry.target;
      bar.style.width = (bar.dataset.value || '0') + '%';
      observer.unobserve(bar);
    });
  }, { threshold: 0.3 });

  bars.forEach(bar => observer.observe(bar));
}


